import type { SiteAdapter, AdapterContext } from "../adapters/base.js";
import type { Url } from "../data-model/primitives.js";
import type { NovelMetadata } from "../data-model/novel.js";
import type { EventBus } from "../core/events.js";
import { NovelMetadataSchema } from "../data-model/schema.js";
import { DownloadError, ParseError } from "../core/errors.js";

export async function fetchMetadataStage(
  adapter: SiteAdapter,
  url: Url,
  ctx: AdapterContext,
  bus: EventBus,
): Promise<NovelMetadata> {
  let raw: NovelMetadata;
  try {
    raw = await adapter.fetchMetadata(url, ctx);
  } catch (cause) {
    if (cause instanceof DownloadError) throw cause;
    throw new ParseError(`fetchMetadata failed for ${url}`, { cause, url });
  }
  const parsed = NovelMetadataSchema.safeParse(raw);
  if (!parsed.success) {
    throw new ParseError(`Invalid NovelMetadata from adapter`, { cause: parsed.error, url });
  }
  bus.emit({ type: "metadata:fetched", metadata: parsed.data });
  return parsed.data;
}
